export default __webpack_public_path__ + "static/media/trending.9a242c75.svg";